import React, {useState, useEffect} from 'react'
import Image from 'next/image';
import CommonPopup from '../../PopupForm/CommonPopup';
import * as Yup from 'yup';
export default function AboutSection({data=null}) {

    const [DataRendered, setDataRendered] = useState(false);
    useEffect(()=>{
      setDataRendered(true)
    },[])
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
      setIsModalOpen(true);
    };
    
    const closeModal = () => {
      setIsModalOpen(false);
    };
  
    const options = {
      btn_name: "Submit"
    }
  
    const phoneRegExp = /^(\+\d{1,4})?(\d{9,14})$/
  
    const fields = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'company_name',
            label: '',
            placeholder: 'Company Name',
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'phone',
            label: '',
            placeholder: 'Phone Number',
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        
        },
        {
            name: 'project_overview',
            label: '',
            placeholder: 'Project Overview',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'project_goal',
            label: '',
            placeholder: 'Project Goal',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'scope_of_work',
            label: '',
            placeholder: 'Scope of Work',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'submission_request',
            label: '',
            placeholder: 'Submission Request',
            type: 'textarea',
            col_row:2,
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'submit_date',
            label: '',
            type: 'date',
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'file_name',
            label: '',
            type: 'file',
            className:'block text-gray-700 w-full h-auto py-3 border focus:outline-none focus-visible:border border-gray-300 px-4 bg-transparent',
            customClass: 'md:col-span-6 col-span-12'
        },
    ];

    return (
        <>
            {(data) &&
                <>
                    {data?.map((item, index) => (
                        <section key={index} className="bg-gradient-to-r from-blue-100 to-blue-[#1b5df3]">
                            <div className="w-11/12 xl:max-w-screen max-w-screen-2xl flex flex-col justify-center mx-auto lg:py-8 py-4">
                                <div className="grid grid-cols-12 gap-4">
                                    <div className="col-span-12 md:col-span-5">
                                        <div className="relative">
                                            <Image priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                src={process.env.IMG_CDN+item?.imageSrc}
                                                alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                                className="w-full h-full border-4 border-white rounded-full"
                                            />
                                            <Image priority={false} 
                                                width={2000} 
                                                height={2000} 
                                                src={process.env.IMG_CDN+item?.iconImageSrc1}
                                                alt={item?.iconAltText1}
                                                className="absolute left-[-80px] bottom-[50px] w-[300px] h-[150px] border-0"
                                            />
                                            <div className="absolute bottom-16 w-auto py-2 px-4 right-0 overflow-hidden flex items-center justify-center bg-white" >
                                                <div className="flex items-center cursor-pointer" >
                                                    <Image priority={false} 
                                                        width={2000} 
                                                        height={2000}
                                                        src={process.env.IMG_CDN+item?.iconImageSrc2}
                                                        alt={item?.iconAltText2}
                                                        className="w-6 h-full mr-2"
                                                    />
                                                    <button className="text-black" onClick={openModal}>{item?.btnTitle}</button>
                                                    <CommonPopup isOpen={isModalOpen} closeModal={closeModal} 
                                                        fields={fields}
                                                        options={options}
                                                        page_name="Conference Coverage Page"
                                                        form_name="request-for-proposal-form"
                                                        formTitle="Request For Proposal"
                                                        endpoint="/enquiry/request-for-proposal"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-7">
                                        <div className="lg:pl-8">
                                            <p className="font-semibold text-[#1b5df3]">{item?.shortTitle}</p>
                                            <h2 className="font-semibold text-2xl text-black my-2">{item?.title}</h2>
                                            <ul className="grid lg:grid-cols-1"> 
                                                {item?.points.map((item, index) => (
                                                    <li key={index}  className="flex items-start mb-2">
                                                        <span className="flex justify-center items-center w-[1rem] h-[1rem] mt-1 px-1 text-xs bg-[#1DA1F2] dark:bg-gray-600 rounded-full">
                                                            <i className="fa fa-angle-right text-white"></i>
                                                        </span>
                                                        <span className="pl-2 text-black text-base">{item?.itemPoint}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                            <p className="font-semibold text-[#1b5df3]">{item?.listTitle}</p>
                                            <ul className="grid lg:grid-cols-2 gap-2">
                                                {item?.listPoints.map((item, index) => (
                                                    <li key={index}  className="flex items-center">
                                                        <span className="flex justify-center items-center w-[1rem] h-[1rem] text-xs bg-[#1DA1F2] dark:bg-gray-600 rounded-full">
                                                            <i className="fa fa-angle-right text-white"></i>
                                                        </span>
                                                        <span className="pl-2 text-black text-sm">{item?.itemPoint}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    ))}
                </>
            }
        </>
    )
}
